'use strict';

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PropTypes = require('prop-types');
var React = require('react');

module.exports = (_temp2 = _class = function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class() {
        var _temp, _this, _ret;

        _classCallCheck(this, _class);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
            height: 0,
            errors: false
        }, _this.receiveMessage = function (e) {
            var msg = JSON.parse(e.data);
            switch (msg.type) {
                case 'heightData':
                    _this.setState({
                        height: msg.data.height
                    });
                    break;
                case 'ajax_event':
                    if (msg.data.eventType == 'start') {
                        if (_this.props.ajaxStartCallback) {
                            _this.props.ajaxStartCallback();
                        }
                    } else {
                        if (_this.props.ajaxStopCallback) {
                            _this.props.ajaxStopCallback();
                        }
                    }
                    break;
                case 'service_error':
                    //does this really need to hold errors as state?
                    _this.setState({
                        errors: msg.data.errors
                    });
                    if (_this.props.errorCallback) {
                        _this.props.errorCallback(msg.data.errors);
                    }
                    break;
                case 'submission_success':
                    _this.setState({
                        height: 0,
                        errors: false
                    });
                    if (_this.props.successCallback) {
                        _this.props.successCallback();
                    }
                    break;
                case 'cancel':
                    if (_this.props.cancelCallback) {
                        _this.props.cancelCallback();
                    }
                    break;
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _class.prototype.componentDidMount = function componentDidMount() {
        window.addEventListener("message", this.receiveMessage, false);
    };

    _class.prototype.componentWillUnmount = function componentWillUnmount() {
        window.removeEventListener("message", this.receiveMessage, false);
    };

    _class.prototype.render = function render() {
        return React.createElement(
            'div',
            { style: { width: "100%", height: this.state.height + "px" } },
            React.createElement('iframe', { height: this.state.height + "px", width: '100%', scrolling: 'no', frameBorder: '0', seamless: 'seamless',
                src: this.props.url, onLoad: this.props.onLoad })
        );
    };

    return _class;
}(React.Component), _class.propTypes = {
    successCallback: PropTypes.func,
    ajaxStartCallback: PropTypes.func,
    ajaxStopCallback: PropTypes.func,
    errorCallback: PropTypes.func,
    cancelCallback: PropTypes.func,
    onLoad: PropTypes.func
}, _temp2);


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/components/payments/PaymentIFrameHost.js
// module id = 329
// module chunks = 0